import React, {Component} from 'react'
import {Form,Select,DatePicker,Input,Icon,message,Tag,Tooltip,AutoComplete } from "antd";
import './newActivityBaseInfostyle.css';
import CheckBoxTableModal from "../../components/CheckBoxTableModal";
import UploadWall from "../../components/upload/UploadWall";
import ChunkUpload from "../../components/upload/ChunkUpload";
import {checkFileStatus} from "../../actions/upload";
import {PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE,FILE_TYPE} from "../../constants";
import {getAttachmentFiles} from "../../actions/newsActivityAction";
import moment from 'moment';
import {applicationName} from "../../utils";

const {Option} = Select;
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const { TextArea } = Input;
class NewActivityBaseInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _items:props.data.eventItem,//所属项目，
            sponsor:props.data.sponsor,//主办单位
            fileList: [],
            treeData: [],
            interviewDate:props.data.interviewDate?moment(props.data.interviewDate.getTime()):undefined,
            endDate:props.data.endDate?moment(props.data.endDate.getTime()):undefined,
            checkboxVisible: false,
            comActivities: {},
            checkBoxColumn: [{
                key: '1',
                title: '任务名称',
                dataIndex: 'name',
                width: '80%',
                align:'center'
            }]
        };
        this.showFileList(props.data.attachmentResourceIds);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            _items:nextProps.data.eventItem,//所属项目，
            sponsor:nextProps.data.sponsor,//主办单位
            interviewDate:nextProps.data.interviewDate?moment(nextProps.data.interviewDate.getTime()):undefined,
            endDate:nextProps.data.endDate?moment(nextProps.data.endDate.getTime()):undefined,
        });
        if(nextProps.data.attachmentResourceIds !== this.props.data.attachmentResourceIds){
            this.showFileList(nextProps.data.attachmentResourceIds);
        }
    }

    componentDidMount() {

    }

    showFileList = (attachmentResourceIds)=>{
        if(attachmentResourceIds && attachmentResourceIds.length > 0){
            getAttachmentFiles(attachmentResourceIds).then(res=>{
                let newFileList = [];
                res && res.map(item=>{
                    newFileList.push({
                        url:"images/file.png",
                        uid:item.id,
                        resourceId:item.id,
                        path:item.url,
                        status:"done",
                        name:item.name,
                        icon:<img src={"images/file.png"} width={70} height={90} />
                    })
                });
                this.setState({ fileList:newFileList });
            })
        }
    };

    handleChangeFileList = ({ file, fileList }) => {
        if(file.status === "done") {
            this.checkStatus(file.response.storageFile.md5, (stateStr)=>{
                let newFileList = fileList.map(item=>{
                    if(item.uid === file.uid){
                        item.url = "";
                        item.path = file.response.url;
                        item.ingStatus = stateStr;
                    }
                    return item;
                });
                this.setState({ fileList:newFileList });
            },(response)=>{
                file.response = response;
                this.saveFile(file).then(res=>{
                    let newFileList = fileList.map(item=>{
                        if(item.uid === file.uid){
                            item.url = "images/file.png";
                            item.path = file.response.url;
                            item.resourceId = res.resourceId;
                            item.icon = <img src={"images/file.png"} width={70} height={90} />;
                        }
                        return item;
                    });
                    this.setState({ fileList:newFileList });
                }).catch(err=>{
                    message.error("附件存放媒资库中出错，请检查文件类型");
                });
            });
        }
        this.setState({ fileList });
    };

    saveFile(file){
        let result = file.response;
        let url;
        let fileTemp = {};
        let params = {};
        let files=[];
        fileTemp.dataSource = 4;
        fileTemp.name = result.storageFile.name;
        fileTemp.ext = result.storageFile.suffix;
        fileTemp.path = result.url;
        fileTemp.size = result.storageFile.size ? result.storageFile.size : file.size;
        fileTemp.md5 = result.storageFile.md5;
        fileTemp.publish=0;
        params.dataSource = 4;
        if(PIC_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/savePicture";
            fileTemp.imageHeight = result.storageFile.height;
            fileTemp.imageWidth = result.storageFile.width;
            files.push(fileTemp);
            params.pictures=files;
        }else if(VIDEO_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveVideo";
            fileTemp.frameHeight = result.storageFile.height;
            fileTemp.frameWidth = result.storageFile.width;
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.videos=files;
        }else if(AUDIO_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveAudio";
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.audios=files;
        }else if(ATTCHMENT_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveOtherFile";
            files.push(fileTemp);
            params.otherFiles=files;
        }
        return new Promise((resolve, reject) => {
            window.$.ajax({
                type: "post",
                url: url,
                cache: false,
                // async: false,
                data: JSON.stringify(params),
                dataType: "json",
                contentType: 'application/json;charset=UTF-8',
                success: function (res) {
                    let data;
                    if(res.data){
                        data=JSON.parse(res.data);
                        resolve(data&&data.length&&data[0]);
                    }
                },error: function (err) {
                    console.log("err:    ", err);
                    reject(err);
                }
            });
        });
    }

    closedCheck(){
        this.setState({
            checkboxVisible:false,
        })
    }

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item=>{
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack){
        setTimeout(()=>{
            checkFileStatus(md5).then(res=>{
                if(res.state !== "mergeComplete"){
                    this.checkStatus(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                }else{
                    overCallBack(res);
                }
            }).catch(()=>{
                overCallBack({});
            });
        }, 100);//每隔一秒钟进行检查一次
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let leixing = ["新闻报道", "选题策划"];
        if(this.props.sysConfig){
            leixing = this.props.sysConfig.getValueByKey("new.activity.leixing", "新闻报道,选题策划").split(",");
        }
        let repalceIsRequire = true;
        let defaultLeixing = undefined;
        if(leixing && leixing.length > 0){
            defaultLeixing = leixing[0];
            leixing.map(lx =>{
                if(lx === this.props.data.leixing){
                    defaultLeixing = this.props.data.leixing
                }
            });
            repalceIsRequire = defaultLeixing !== "选题策划";
        }

        let interviewDateIsRequire = repalceIsRequire;
        return <div className={"newActivityBaseInfo_container"} style={{overflowX:"hidden"}}>
            <table className={"form_table"}>
                <tbody>
                <tr><td className={"form_name_title"}>任务类型<span style={{color:'red'}}>*</span></td>
                    <td className={"form_name_title"}>任务名称<span style={{color:'red'}}>*</span></td>
                    <td className={"form_name_title"}>所属项目</td></tr>
                <tr><td className={"form_name_value"}>
                    {getFieldDecorator('leixing', {
                        rules: [{ required: true, message: '请选择任务类型' }],
                        initialValue : defaultLeixing,
                    })(<Select
                        onChange={(leixing)=>{
                            this.props.leixingChange(leixing)
                        }}
                        style={{width:"100%"}}>
                        {leixing.map((option, index)=><Option value={option} key={index}>{option}</Option>)}
                    </Select>)}
                </td><td className={"form_name_value"}>
                    {getFieldDecorator('title', {
                        rules: [{ required: true, message: '请输入任务名称' }],
                        initialValue: this.props.data.title
                    })(<Input maxLength={200} />)}
                </td><td className={"form_name_value"}>
                    <span className={"ant-input-affix-wrapper"}>
                        <table className={"form_activity_input"} border={0} cellSpacing={0} cellPadding={0} width={"100%"}>
                            <tbody>
                                <tr>
                                    <td>
                                        <div style={{overflow:"auto",height:"30px", padding:"4px 5px"}}>
                                            {
                                                this.state._items && this.state._items.map(item=>{
                                                    return <Tooltip placement={"top"} key={"Tooltip"+item.id} title={item.name}><Tag
                                                        className={"text-pointer cmSitesTag"}
                                                        style={{maxWidth:"240px"}}
                                                        closable onClose={()=>{
                                                        this.setState(prevState=> {
                                                            let newItems = [];
                                                            prevState._items && prevState._items.map(newItem => {
                                                                if(newItem.id !== item.id){
                                                                    newItems.push(newItem);
                                                                }
                                                            });
                                                            prevState._items = newItems;
                                                            this.props.eventItemChange(newItems);
                                                            return prevState;
                                                        });
                                                    }}>{item.name}</Tag></Tooltip>
                                                })
                                            }
                                        </div>
                                    </td>
                                    <td width={20}>
                                        <Icon type={"select"} style={{cursor:"pointer",color:"#00000040",marginTop:"3px"}} onClick={()=>this.setState({checkboxVisible:true})} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </span>
                </td></tr>
                <tr>
                    <td className={"form_name_title"}>活动时间{interviewDateIsRequire?<span style={{color:'red'}}>*</span>:""}</td>
                    <td className={"form_name_title"}>活动地点{repalceIsRequire?<span style={{color:'red'}}>*</span>:""}</td>
                    <td className={"form_name_title"}>回稿时间</td>
                </tr>
                <tr><td className={"form_name_value"}>
                    <DatePicker style={{width:"100%"}}
                                value={this.state.interviewDate?this.state.interviewDate:undefined}
                                onChange={interviewDate=>{
                                    this.setState({interviewDate});
                                    this.props.interviewDateChange(interviewDate);
                                }}
                                showTime format="YYYY-MM-DD HH:mm:ss" />
                </td><td className={"form_name_value"}>
                    {getFieldDecorator('place', {
                        rules: [{ required: repalceIsRequire, message: '请输入活动地点' }],
                        initialValue: this.props.data.place
                    })(<Input maxLength={200}/>)}
                </td><td className={"form_name_value"}>
                    <DatePicker style={{width:"100%"}}
                                value={this.state.endDate?this.state.endDate:undefined}
                                onChange={endDate=>{
                                    this.setState({endDate:endDate});
                                    this.props.endDateChange(endDate);
                                }}
                                showTime format="YYYY-MM-DD HH:mm:ss" />
                </td></tr>
                <tr>
                    <td className={"form_name_title"}>主办单位</td>
                    <td className={"form_name_title"}>活动联系人</td>
                    <td className={"form_name_title"}>联系方式</td></tr>
                <tr><td className={"form_name_value"}>
                    <AutoComplete
                        style={{ width: "100%" }}
                        dataSource={(()=>{
                            let sponsor = this.props.sysConfig && this.props.sysConfig.getValueByKey("new.activity.sponsor", "“清华辅导员”微信公众号,《北京日报》,《光明日报》,《中国高等教育》,《中国纪检监察报》,《中国教育报》,《中国青年报》,21世纪经济客户端,CCTV,CCTV-1 新闻联播,CCTV-13,iCenter,TMS协会,保密办,保卫部,北京青年报,北京清华长庚医院,北京日报,北京日报客户端,北京晚报,北京信息科学与技术国家研究中心,本招办,博士生讲师团,材料学院,财务处,参考消息,产业发展与环境治理研究中心,昌平办,车辆学院,出土文献中心,大理日报,大数据研究中心,档案馆,党办,党办校办,党委保卫部（保卫处）,党委统战部,党委武装部（国防教育与人才培养办公室）,党委宣传部（新闻中心）,党委学生部（学生处）,党委巡察工作办公室,党委组织部（含机关党委）,低碳能源实验室,地学系,第一附属医院,电机系,电子工程系,电子系,对口支援办,俄罗斯研究院,发展规划处,法学院,法制日报,法治与法务办公室,高技术实验室,高校思政网,高研院,工会,工物系,工业工程系,公共卫生与健康学院,公管学院,光明日报,光明日报客户端,光明网,国际处,国际合作与交流处（港澳台办）,国内合作办,航发院,航天航空学院,航院,核研院,后勤党委,华信医院（第一附属医院）,化工系,化学系,环境学院,会计核算中心,机关党委,机械系,基础工业训练中心,基建处,基金会,计算机系,纪委,纪委办公室,纪委办监察室,技术转移研究院,继教学院,继续教育学院,检察日报,建筑学院,建筑学院（含建环）,交叉信息研究院,交叉信息院,教师发展中心,教务处,教研院,教育基金会,教育研究院,接待服务中心,街道办事处,洁华幼儿园,解放军报,金融学院,京报网,经管学院,经济参考网,经济日报,经资办,精神文明报,精仪系,科技日报,科技日报微信号,科学博物馆（筹）,科学网,科研院,拉美中心,离退休处,离退休工作部（离退休处）,理论网,临床医学院,绿办,马克思主义学院,美术学院,美院,南方都市报,脑与智能实验室,能动系,澎湃新闻,澎湃新闻客户端,澎湃新闻网,汽车系,清华PPP研究中心,清华-伯克利深圳学院,清华大学本科教学,清华大学出版社,清华大学公众号,清华大学教育基金会公众号,清华大学美术学院,清华大学微信公众号,清华大学医院,清华大学中国新型城镇化研究院,清华附小,清华附中,清华校友总会,清华校友总会（同校友办）,清华新闻网,清华研读间,清华长庚医院,清小暑微信公众号,全球创新学院,人民论坛网,人民日报,人民日报海外版,人民网,人民政协报,人事处（教师工作部）,人文清华,人文清华讲坛,人文学院,柔电中心,软件学院,三亚中心,山东卫视,社科学院,深耕计划,深圳国际研究生院,深圳新闻网,深圳研究生院,审计室,生命学院,生态文明清华园公众号,实验室管理处,世界大学气候变化联盟秘书处,书院,书院管理中心,数学科学中心,数学系,水利系,苏世民书院,体育部,体育代表队,天文系,同方威视,图书馆,土木系,土木系（含建管）,土水学院,团委,外文系,网络研究院,微纳电子系,未来实验室,文化建设办公室（文物保护办公室）,文化素质教育基地,文科处,文孙宇,无障碍发展研究院,武装部,物理系,西昌都市报,校办,校机关党委,校史馆,校史研究室（党史研究室、校史馆）,校团委,校学生会,校研会,校研究生会,校研团委,校友会,校友总会,校园专项办,新华每日电讯,新华社,新华社客户端,新华网,新京报,新京报网,新闻联播,新闻学院,新闻中心,新雅书院,信息化工作办公室,信息化技术中心,信息科学与技术国家研究中心,修缮校园管理中心,学科办,学生部,学生处,学生对外交流协会,学生会,学生科协,学生全球胜任力发展指导中心,学生社区管理服务中心,学生社区中心,学生学习与发展指导中心,学生职业发展指导中心,学术委员会,学堂在线,学位办,巡察办,训练中心,研工部,研究生会,研究生团委,研究生院,研团委,央广网,央视网,央视新闻,央视新闻客户端,药学院,一附院,医工交叉研究院,医学院,艺教中心,艺术博物馆,饮食中心,语言中心,玉泉医院（第二附属医院）,长庚医院,长江日报,招办,招生办公室,政策研究室,职业发展指导中心,职业发展中心,智库中心,中非领导力发展中心,中国电子报,中国高等教育,中国华能微信号,中国环境报,中国纪检监察报,中国教育报,中国教育新闻网,中国教育在线,中国经济时报,中国科技网,中国科学报,中国科学技术协会,中国汽车报,中国青年报,中国青年报客户端,中国日报网,中国社会科学网,中国新闻网,中国新型城镇化研究院,中华人民共和国应急管理部微信号,中央纪委国家监委网,中央纪委国家监委网站,终身教育处,资产管理处,自动化系,总会计师办公室,总务长办公室（同后勤管理处）,组织部,最高人民法院微信号");
                            console.log(sponsor)
                            return sponsor?sponsor.split(","):""
                        })()}
                        defaultValue={this.props.data.sponsor}
                        placeholder="请输入主办单位"
                        onChange={(value)=>{
                            this.setState({
                                sponsor:value
                            });
                            this.props.sponsorChange(value);
                        }}
                        filterOption={(inputValue, option) =>
                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                    />
                </td><td className={"form_name_value"}>
                    {getFieldDecorator('contacts', {
                        rules: [{ required: false, message: '请输入活动联系人' }],
                        initialValue: this.props.data.contacts
                    })(<Input  maxLength={50} />)}
                </td><td className={"form_name_value"}>
                    {getFieldDecorator('contactsWay', {
                        rules: [{ required: false, message: '请输入联系方式' }],
                        initialValue: this.props.data.contactsWay
                    })(<Input maxLength={50} />)}
                </td></tr>
                </tbody>
            </table>
            <div className={"form_activity_content"}>
                <span className={'title'}>任务内容<span style={{color:'red'}}>*</span></span>
                {getFieldDecorator('content', {
                    rules: [
                        {
                            required: true,
                            message: '请输入任务内容',
                        },
                    ],
                    initialValue: this.props.data.content
                })(<TextArea rows={4}/>)}
                <span className={'title'}>附件</span>

                <UploadWall
                    accept={"."+FILE_TYPE.join(",.")}
                    multiple={true}
                    action="/cm-sites-pms/index/uploadFile"
                    listType="picture-card"
                    fileList={this.state.fileList}
                    customRequest={new ChunkUpload({
                        checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                        checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                        uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                        chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                        mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                    }).start}
                    icons={["download", "delete"]}
                    uploadBtnName={"上传附件"}
                    onChange={this.handleChangeFileList}
                    onRemove={this.handleRemove}
                    listType={"list"}
                    onDownload={(file)=>{
                        if(file.path.indexOf("?") === -1){
                            window.location.href = file.path + "?download=1";
                        }else{
                            window.location.href = file.path + "&download=1";
                        }
                    }}
                />
            </div>
            <CheckBoxTableModal
                selectedRowKeys={(()=>{
                    let keys = [];
                    this.state._items && this.state._items.map(item=>{
                        keys.push(item.id);
                    });
                    return keys;
                })()} title={'请选择所属项目'}
                dataUrl={"/cm-sites-"+applicationName() +"/interviewEvent/list"}
                dataParam={{type:2}}
                columns={this.state.checkBoxColumn}
                onOk={(selectRows)=>{
                    let _items = selectRows;
                    this.setState({
                        checkboxVisible: false,
                        _items
                    });
                    this.props.eventItemChange(_items);
                }}
                visible={this.state.checkboxVisible} closeModal={this.closedCheck.bind(this)}/>
        </div>
    }
}
NewActivityBaseInfo.defaultProps = {
    data:{},
    eventItemChange:()=>{},
    sponsorChange:()=>{},
    leixingChange:()=>{},
    interviewDateChange:()=>{},
    endDateChange:()=>{}
};
export default Form.create()(NewActivityBaseInfo);